import angular from 'angular';
import './api/mailchimp';

angular.module('folkeuni').factory('Mailchimp', function (MailchimpApi, $q) {
    var mailchimp = this;
    var subscriber;

    mailchimp.categoriesGetBySiteId = function (siteId, email) {
        var categories = [];
        var deferred = $q.defer();

        if (email !== undefined && email !== "") {
            subscriber = undefined;
            mailchimp.getSubscriber(siteId, email).then(function (successResponse) {
                //If response contains property statuscode, subscriber was not found
                if (!successResponse.hasOwnProperty("statusCode")) {
                    subscriber = successResponse;
                }
            },
                function (error) {
                    deferred.reject(error);
                }).finally(function () {
                    setCategories();
                });
        } else {
            setCategories();
        }

        function setCategories() {
            if (siteId == 1) { //Aarhus

                //Department
                var category = {
                    label: "By",
                    options: []
                };

                category.options.push({
                    id: "953977b091",
                    label: "Aarhus",
                    selected: setCategoryStatus("953977b091", false)
                });
                category.options.push({
                    id: "b4c05af984",
                    label: "Emdrup",
                    selected: setCategoryStatus("b4c05af984", false)
                });
                category.options.push({
                    id: "97363676c2",
                    label: "Herning",
                    selected: setCategoryStatus("97363676c2", false)
                });

                categories.push(category);

                //Festival
                category = {
                    label: "Festival",
                    options: []
                };

                category.options.push({
                    id: "2c42035494",
                    label: "Århundredets Festival i Aarhus",
                    selected: setCategoryStatus("2c42035494", false)
                });
                category.options.push({
                    id: "f2f731e4cf",
                    label: "PARK i Aarhus",
                    selected: setCategoryStatus("f2f731e4cf", false)
                });
                category.options.push({
                    id: "a4eebd8d7e",
                    label: "Hearts & Minds i Aarhus",
                    selected: setCategoryStatus("a4eebd8d7e", false)
                });
                /*
                    category.options.push({
                        id: "94a861a2ba",
                        label: "Hearts & Minds i København",
                        selected: setCategoryStatus("94a861a2ba", false)
                    });
                */
                category.options.push({
                    id: "ad08ebd238",
                    label: "Historiske Dage i København",
                    selected: setCategoryStatus("ad08ebd238", false)
                });
                

                categories.push(category);


                //Digitalt
                category = {
                    label: "Digitalt",
                    options: []
                };

                category.options.push({
                    id: "2a703bc3e4",
                    label: "Folkeuniversitetet online – livestreams, podcasts og læsestof",
                    selected: setCategoryStatus("2a703bc3e4", false)
                });
               
                categories.push(category);


                // Removed: 18-09-2017
                // category.options.push({
                //   id: "3c148f2ea8",
                //   label: "Nordiske Nätter",
                //   selected: false
                // });
                // category.options.push({
                //   id: "68ca6307be",
                //   label: "Reformation<br/>(Landsdækkende)",
                //   selected: false
                // });

                //categories.push(category);

                //category = {
                //  label: "Netværk",
                //  options: []
                //};
                //category.options.push({
                //  id: "4d56b6a688",
                //  label: "Skolenetværk",
                //  selected: false
                //});
                // category.options.push({
                //   id: "3aedaa44f6",
                //   label: "English",
                //   selected: false
                // });
                // categories.push(category);

            } else if (siteId == 3) { //Odense

                //Department
                var categorySite3 = {
                    label: "Afdeling",
                    options: []
                };

                categorySite3.options.push({
                    id: "55f29190bd",
                    label: "Odense",
                    selected: setCategoryStatus("55f29190bd", true)
                });
                categorySite3.options.push({
                    id: "f4a04d2c17",
                    label: "Kolding",
                    selected: setCategoryStatus("f4a04d2c17", true)
                });
                // category.options.push({
                //   id: "c6b59b7022",
                //   label: "Esbjerg",
                //   selected: true
                // });

                categories.push(categorySite3);


            } else if (siteId == 15) { //Aalborg

                //Department

                var categorySite15 = {
                    label: "Afdeling",
                    options: []
                };

                categorySite15.options.push({
                    id: "6eb1ca93f8",
                    label: "Aalborg",
                    selected: setCategoryStatus("6eb1ca93f8", true)
                });

                categories.push(categorySite15);

                categorySite15 = {
                    label: "Kategorier",
                    options: []
                };

                categorySite15.options.push({
                    id: "1a86eeed12",
                    label: "Ledelse og Kommunikation",
                    selected: setCategoryStatus("1a86eeed12", false)
                });
                categorySite15.options.push({
                    id: "cfdc72b751",
                    label: "Sprog og Litteratur",
                    selected: setCategoryStatus("cfdc72b751", false)
                });
                categorySite15.options.push({
                    id: "ed8243057d",
                    label: "Historie",
                    selected: setCategoryStatus("ed8243057d", false)
                });
                categorySite15.options.push({
                    id: "414d9db88b",
                    label: "Filosofi og Religion",
                    selected: setCategoryStatus("414d9db88b", false)
                });
                categorySite15.options.push({
                    id: "c91e08237a",
                    label: "Musik, Film og Teater",
                    selected: setCategoryStatus("c91e08237a", false)
                });

                categories.push(categorySite15);

                categorySite15 = {
                    label: "&nbsp;",
                    options: []
                };

                categorySite15.options.push({
                    id: "c9b97a5874",
                    label: "Kunst og Arkitektur",
                    selected: setCategoryStatus("c9b97a5874", false)
                });
                categorySite15.options.push({
                    id: "66bf31b64c",
                    label: "Kultur, Sociologi og Samfund",
                    selected: setCategoryStatus("66bf31b64c", false)
                });
                categorySite15.options.push({
                    id: "60277ef25b",
                    label: "Naturvidenskab",
                    selected: setCategoryStatus("60277ef25b", false)
                });
                categorySite15.options.push({
                    id: "655e99241c",
                    label: "Sundhed og Psykologi",
                    selected: setCategoryStatus("655e99241c", false)
                });
                categorySite15.options.push({
                    id: "5a234222d7",
                    label: "Kultur- og Naturrejser",
                    selected: setCategoryStatus("5a234222d7", false)
                });

                categories.push(categorySite15);
            }
            deferred.resolve(categories);
        }
        return deferred.promise;
    };

    mailchimp.subscribe = function (departmentId, subscriberObj) {

        var deferred = $q.defer();

        MailchimpApi.subscribe(departmentId, subscriberObj).then(function (successResponse) {
            deferred.resolve(successResponse.data);
        },
            function (errorResponse) {
                deferred.reject(errorResponse);
            });

        return deferred.promise;
    };

    mailchimp.getSubscriber = function (departmentId, email) {

        var deferred = $q.defer();
        MailchimpApi.getSubscriber(departmentId, email).then(function (successResponse) {
            deferred.resolve(successResponse.data);
        },
            function (errorResponse) {
                deferred.reject(errorResponse);
            });

        return deferred.promise;
    };



    function setCategoryStatus(id, defaultValue) {
        //Set defaultvalue
        if (defaultValue === undefined) {
            defaultValue = true;
        }
        if (subscriber === undefined) {
            return defaultValue;
        }
        return subscriber.interests.hasOwnProperty(id) ? subscriber.interests[id] : defaultValue;
    }

    return mailchimp;
});
